import {handOver, takeHandover} from '@/utils/handover'

/**
 * Uma recusa de entrada, do jeito que a tela precisa dela — e a entrega dela de uma tela à outra.
 *
 * **Por que um objeto, e não só a frase**: entrar pelo Google é um clique num popup, e quem tem
 * mais de uma conta aberta no navegador às vezes nem repara em qual entrou. Sem o endereço, a
 * tela mostra um aviso vermelho sob um campo VAZIO: a pessoa lê "não foi aprovado" e não sabe de
 * quem. Com ele, o campo fica preenchido — diz de quem é a recusa e já serve para tentar pela
 * senha.
 *
 * **Por que o `notApproved`**: é a única recusa que muda de tela. Erro do provedor — popup
 * bloqueado, conta que já tem senha — se resolve ali mesmo; convite esperando aprovação, não.
 */
export type AuthRefusal = {
    message: string
    email: string
    notApproved: boolean
}

/**
 * A chave é o destino, como no `collectionReadKey`: quem entrega não sabe o que a outra tela vai
 * fazer com isso, só para quem era.
 */
const KEY = 'auth-refusal'

/**
 * Deixa a recusa para o login, que é o que o cadastro faz quando o convite espera aprovação.
 *
 * **Em memória, pelo `handover`, e não na URL**: a frase é texto traduzido, e frase de erro em
 * query string volta ao recarregar a página e pode ser trocada por quem monta o link. Como toda
 * entrega, esta se consome uma vez e some — o login abre vazio no F5, que é o certo.
 */
export function handOverRefusal(refusal: AuthRefusal): void {
    handOver(KEY, refusal)
}

/** A recusa que a outra tela deixou, ou null — e então o login abre limpo, como sempre. */
export function takeRefusal(): AuthRefusal | null {
    return takeHandover(KEY)
}
